import { SidenavState } from './store.reducers.sidenav';

const baseSidenav = {
  isLoading: false,
  loaded: false,
  showCategoriesAllBtn: true,
  isCategoriesMultiselect: true,
  isExtraUrlParams: false,
  multiple: false,
  resolveData: false,
  containsPeriod: false,
  categories: [],
  staticLinks: [],
};

export const FOCUS_SIDENAV_DEFAULT: SidenavState = {
  ...baseSidenav,
  appIcon: 'product_focus',
  appTitle: 'sidenav.focus.appTitle',
  categoriesTitle: 'sidenav.focus.categoriesTitle',
  categoriesAllTitle: 'sidenav.focus.categoriesAllTitle',
  isExtraUrlParams: true,
  path: '/focus',
  resolveData: true,
  containsPeriod: true,
  dataService: 'configDS',
};

export const PROFILES_SIDENAV_DEFAULT: SidenavState = {
  ...baseSidenav,
  appIcon: 'product_profiles',
  appTitle: 'sidenav.profiles.appTitle',
  categoriesTitle: 'sidenav.profiles.categoriesTitle',
  categoriesAllTitle: 'sidenav.profiles.categoriesAllTitle',
  isExtraUrlParams: true,
  path: '/profiles',
  resolveData: true,
  dataService: 'configDS',
  containsMap: true,
};

export const ANALYTICS_AREAS_DEFAULT: SidenavState = {
  ...baseSidenav,
  appIcon: 'product_analytics',
  appTitle: 'sidenav.analytics.appTitle',
  appConfig: {
    reportPath: '/analytics/report',
    mapPath: '/analytics/map',
  },
  categoriesTitle: 'sidenav.analytics.categoriesTitle',
  categoriesAllTitle: 'sidenav.analytics.categoriesAllTitle',
  path: '/analytics',
  resolveData: true,
  dataService: 'configDS',
};

export const WORK_AREAS_DEFAULT: SidenavState = {
  ...baseSidenav,
  appIcon: 'product_work',
  appTitle: 'sidenav.work.appTitle',
  categoriesTitle: 'sidenav.work.categoriesTitle',
  categoriesAllTitle: 'sidenav.work.categoriesAllTitle',
  path: '/work',
  resolveData: true,
  dataService: 'configDS',
};

export const SUBMISSION_SIDENAV_DEFAULT: SidenavState = {
  ...baseSidenav,
  appIcon: 'product_submission',
  appTitle: 'sidenav.submission.appTitle',
  categoriesTitle: 'sidenav.submission.categoriesTitle',
  categoriesAllTitle: 'sidenav.submission.categoriesAllTitle',
  path: '/submission',
  resolveData: false,
  dataService: 'configDS',
  staticLinks: [
    { link: 'submission', title: 'sidenav.submission.staticLinks.filesLogs', icon: 'svg-piece_of_paper' },
    { link: 'submission/upload', title: 'sidenav.submission.staticLinks.upload', icon: 'submit' },
  ],
};

export const MATCHING_SIDENAV_DEFAULT: SidenavState = {
  ...baseSidenav,
  appIcon: 'product_matching',
  appTitle: 'sidenav.matching.appTitle',
  categoriesTitle: 'sidenav.matching.categoriesTitle',
  categoriesAllTitle: 'sidenav.matching.categoriesAllTitle',
  path: '/matching',
  resolveData: false,
  dataService: 'configDS',
  staticLinks: [
    {
      link: 'matching',
      title: 'sidenav.matching.staticLinks.engineRules',
      icon: 'parent_node',
    },
  ],
};

export enum APPS {
  focus = 'focus',
  analytics = 'analytics',
  profiles = 'profiles',
  submission = 'submission',
  matching = 'matching',
  work = 'work'
}

export const GAI_ASSISTANT_APP_Name = 'assistant';
export const GAI_ASSISTANT_APP_ID = 12;

export const APPS_MAP = new Map<APPS, SidenavState>([
  [APPS.focus, FOCUS_SIDENAV_DEFAULT],
  [APPS.analytics, ANALYTICS_AREAS_DEFAULT],
  [APPS.work, WORK_AREAS_DEFAULT],
  [APPS.profiles, PROFILES_SIDENAV_DEFAULT],
  [APPS.submission, SUBMISSION_SIDENAV_DEFAULT],
  [APPS.matching, MATCHING_SIDENAV_DEFAULT],
]);